import React from 'react';
import { AppLayout } from '../../app/appLayout.js';

const HomeScreen = () => {
    return (
        <AppLayout>
            <h2>Welcome to WR Nutrition</h2>
        </AppLayout>
    );
};

export { HomeScreen };
